<template>
	<div class="col matches-group__component gsap-fade-up">
		<div class="row">
			<div class="col header">
				<div>
					<h6>Découvrir nos équipes</h6>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-6 col-xl-4" v-for="team in teams" v-if="team.show_on_home == 1" :key="team.id">
				<a
					@click.prevent="goToTeam(team)"
					class="league-calendar">
					<p>Équipes</p>
					<h6>{{team.name}}</h6>
					<span>Voir l'équipe</span>
				</a>
			</div>
		</div>
	</div>
</template>
<script>
	import { mapState } from 'vuex'

	export default {
		name: 'NextMatches',
		methods: {
			goToTeam(team) {
				if (team.category_id) {
					this.teamsWithCategories.forEach( teamCategory => {

						if (teamCategory.children.length == 0) {
							if (team.category_id == teamCategory.id) {
								this.$router.push({name: 'page', params: {sectionSlug: this.teamsSection.slug, subsectionSlug: teamCategory.slug, pageSlug: team.slug}  })
							}
						} else {
							this.$router.push({name: 'page', params: {sectionSlug: this.teamsSection.slug, subsectionSlug: this.juniors.slug, pageSlug: team.slug}  })
						}
						
					})
				}
			}
		},
		computed: {
			...mapState([
				'teams',
				'teamsWithCategories',
				'allSections'
			]),
			teamsSection() {
				return this.allSections.filter( i => i.type == 'teams')[0]
			},
			juniors() {
				for (const team in this.teamsWithCategories) {
					if (this.teamsWithCategories.hasOwnProperty(team)) {
						if (this.teamsWithCategories[team].type == 'juniors') {
							return this.teamsWithCategories[team]
						}
					}
				}
			}
		}
	}
</script>